var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "3582dc8bc4e8f011b69b1ee1ef212662.png",
    width: 150,
    height: 150
});